const value = {
    pointsToNextLevel: 'Баллов до следующего уровня',
    pointsToCompletion: 'Баллов до полного прохождения',
    noAssignedUnits: 'У вас нет назначенных юнитов',

    learnAndLevelUp: 'Повышай уровень с обучением',
    allUnitsPassed: 'Все юниты пройдены',
    toNextLevel: 'До следующего уровня:',
    toMax: 'До максимума:',
    junior: 'Новичок',
    middle: 'Мидл',
    senior: 'Чемпион',
  };

export default value;
